let path = window.location.pathname;
if (path.lastIndexOf('/') !== path.length-1) {
    path = path + '/';
}

export const paths = {
    SUGGEST_ADDRESS: path,
    SUGGEST_ADDRESS_SUBMITTED: `${path}submitted`,
};


// WEBPACK FOOTER //
// ./src/routes/routes.tsx